export const CARD_THEME = {
  padding: {
    small: 4,
    medium: 6,
  },
  borderColor: "default-border-color",
  radius: "rounded",
} as const;
